import {DependencyList, RefObject, useEffect, useRef, useState} from 'react'
import BlazeSlider, {BlazeConfig} from 'blaze-slider'

export type useBlazeSliderReturn = {
    elRef: RefObject<HTMLDivElement>
    slider: BlazeSlider | undefined
    currentSlide: number
    totalSlides: number
}

const useBlazeSlider = (config: BlazeConfig, deps?: DependencyList): useBlazeSliderReturn => {
    const [_, toggle] = useState<boolean>(false)
    const [slider, setSlider] = useState<BlazeSlider>()
    const elRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (!elRef.current) {
            return
        }

        const newSlider = new BlazeSlider(elRef.current, config)
        newSlider.onSlide(() => toggle((prev) => !prev))
        setSlider(newSlider)

        return () => newSlider?.destroy()
    }, deps ?? [])

    return {
        elRef,
        slider,
        currentSlide: slider?.stateIndex ?? 0,
        totalSlides: slider?.totalSlides ?? 1,
    }
}

export default useBlazeSlider
